import { Button, Dialog, IconButton, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../../api/auth/itemCategories/bookableDurations";
import useBookableDurationStore from "../../../stores/useBookableDurationStore";
import BookableDurationForm from "../bookableDurations/BookableDurationForm";
import WushSortableTable from "../../layout/WushSortableTable";
import { Delete, Edit } from "@mui/icons-material";
import DurationDescription from "../../text/DurationDescription";
import destroy from "../../../api/auth/itemCategories/bookableDurations/destroy";

export default function BookableDurations({ itemCategory }) {
  const { bookableDurations, setBookableDurations, removeBookableDuration } = useBookableDurationStore();
  const [ editingDuration, setEditingDuration ] = useState();

  useEffect(() => {
    index(itemCategory.id, (response) => {
      setBookableDurations(response);
    });
  }, []);

  const handleDelete = (bookableDuration) => {
    destroy(itemCategory.id, bookableDuration.id, () => {
      removeBookableDuration(bookableDuration);
    });
  };

  return (
    <Stack>
      <Stack direction="row" spacing={2}>
        <Typography variant="h5">Booking options</Typography>
      </Stack>
      <Stack mb={2}>
        <Typography variant="body1">
          Use booking options to configure how items in this category can be booked.
        </Typography>
      </Stack>
      <Stack direction="row" mb={2}>
        <Button variant="contained" onClick={() => setEditingDuration({})}>
          New Booking Option
        </Button>
      </Stack>
      <Stack>
        <WushSortableTable
          headers={[
            {
              key: "name",
              label: "Name"
            },
            {
              label: "Description",
              customValue: (row) => <DurationDescription bookableDuration={row} />
            },
            {
              label: "Price",
              customValue: (row) => `$${row.price_dollars}`
            },
            {
              label: "Actions",
              customValue: (row) => (
                <Stack direction="row">
                  <IconButton onClick={() => setEditingDuration(row)}>
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(row)}>
                    <Delete />
                  </IconButton>
                </Stack>
              )
            },
          ]}
          data={bookableDurations}
        />
      </Stack>
      <Dialog
        open={editingDuration}
        onClose={() => setEditingDuration(null)}
      >
        <Stack
          p={2}
          width={{ xs: "100%", sm: "500px" }}
        >
          <Stack mb={2}>
            <Typography variant="h4">{editingDuration?.id ? "Edit option" : "New option"}</Typography>
          </Stack>
          <BookableDurationForm
            bookableDuration={editingDuration}
            itemCategory={itemCategory}
            afterCreate={() => setEditingDuration(null)}
            afterUpdate={() => setEditingDuration(null)}
          />
        </Stack>
      </Dialog>
    </Stack>
  );
}